import styled from 'styled-components';

import {
  colorAccentLighten95,
  colorBlack900,
  colorGrey200,
  colorGrey400,
  colorWhite,
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 12px;
  background: ${colorAccentLighten95};
  border-radius: 8px;

  @media ${mediaQueryMobileLargeMin} {
    gap: 0;
    padding: 20px 16px;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const SummaryTitle = styled.p`
  margin: 0;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
`;

export const RateRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-family: ${fontFamilyPrimary};
  font-size: 24px;
  line-height: 32px;
  color: ${colorBlack900};
`;

export const RateValue = styled.span`
  font-weight: 700;
`;

export const RateArrow = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: rgba(17, 21, 18, 0.4);

  & > svg {
    width: 15px;
    height: 10px;
    fill: currentColor;
  }
`;

export const InputsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 48px;
  grid-template-rows: 48px 48px;
  gap: 16px;
  align-items: center;
  width: 100%;

  & > *:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }

  & > *:nth-child(2) {
    grid-column: 2;
    grid-row: 1 / 3;
    align-self: center;
  }

  & > *:nth-child(3) {
    grid-column: 1;
    grid-row: 2;
  }

  @media ${mediaQueryMobileLargeMin} {
    display: flex;
    flex: 0 0 328px;
    width: 328px;
    max-width: 328px;
    min-width: 0;

    & > *:nth-child(1),
    & > *:nth-child(2),
    & > *:nth-child(3) {
      grid-column: auto;
      grid-row: auto;
      align-self: auto;
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  height: 48px;
  padding: 0 12px;
  background: ${colorWhite};
  border: 1px solid ${colorGrey200};
  border-radius: 4px;

  ${({ $isFocused }) =>
    $isFocused &&
    `
    box-shadow: 0 0 0 2px #35a47c;
  `}
`;

export const ConverterInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  padding: 0;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
  background: transparent;

  &:focus {
    outline: none;
  }
`;

export const CurrencyCode = styled.span`
  flex-shrink: 0;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorGrey400};
`;

export const ReverseButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${colorWhite};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
  cursor: pointer;

  & > svg {
    width: 18px;
    height: 14px;
    fill: ${colorBlack900};
    transform: rotate(90deg);
    transition: transform 0.3s;
  }

  @media ${mediaQueryMobileLargeMin} {
    & > svg {
      transform: rotate(0deg);
    }

    &:hover > svg {
      transform: rotate(180deg);
    }
  }
`;
